import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';

@Component({
  selector: 'app-inspection-stage-list',
  templateUrl: './inspection-stage-list.component.html',
  styleUrl: './inspection-stage-list.component.css',
})
export class InspectionStageListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'srNo',
    'projectName',
    'inspector',
    'lrsCorridor',
    'inspectionDate',
    'compliance',
    'action',
  ];

  dataSource = new MatTableDataSource<Record<string, unknown>>([]);
  searchKeyword = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(event: Event): void {
    this.searchKeyword = (event.target as HTMLSelectElement).value;
    this.fetchData();
  }

  fetchData(): void {
    this.apiService.listProjectInspectionStages({ search: this.searchKeyword }).subscribe({
      next: (res: { data?: Record<string, unknown>[] }) => {
        this.dataSource.data = res.data || [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.message || 'Load failed');
      },
    });
  }

  deleteRecord(item: { id: number; project_name?: string }): void {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '400px',
      data: { itemName: item.project_name || 'inspection' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.apiService.deleteProjectInspectionStage(item.id).subscribe({
          next: () => {
            this.toastrMsgService.success('Inspection deleted');
            this.fetchData();
          },
          error: (err) => this.toastrMsgService.error(err?.error?.message || 'Delete failed'),
        });
      }
    });
  }

  formatLrsCorridor(row: Record<string, unknown>): string {
    const domainData = this.parseJsonField(row['domain_data']);
    const lrs = (domainData['lrs'] as Record<string, unknown>) || {};
    if (!lrs['route_id']) return '—';
    const parts: string[] = [`Route #${lrs['route_id']}`];
    if (lrs['chainage']) parts.push(String(lrs['chainage']));
    else if (lrs['from_km'] != null && lrs['to_km'] != null) {
      parts.push(`${lrs['from_km']}–${lrs['to_km']} km`);
    }
    return parts.join(' · ');
  }

  openInspectionOnMap(row: Record<string, unknown>): void {
    const domainData = this.parseJsonField(row['domain_data']);
    const lrs = (domainData['lrs'] as Record<string, unknown>) || {};
    const queryParams: Record<string, string | number> = { tab: 'lrs' };
    if (lrs['route_id']) queryParams['route_id'] = Number(lrs['route_id']);
    if (lrs['from_km'] != null) queryParams['from_km'] = Number(lrs['from_km']);
    if (lrs['to_km'] != null) queryParams['to_km'] = Number(lrs['to_km']);
    if (row['project_id']) queryParams['project_id'] = Number(row['project_id']);
    void this.router.navigate(['/home/geospatial'], { queryParams });
  }

  private parseJsonField(raw: unknown): Record<string, unknown> {
    if (!raw) return {};
    if (typeof raw === 'object') return raw as Record<string, unknown>;
    try {
      return JSON.parse(String(raw));
    } catch {
      return {};
    }
  }
}
